module.exports = __webpack_public_path__ + "img/react-native-icon.6ab1ece6.png";